import { DataGrid, GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';

import { Form, useGetForms } from 'api/hooks/private/forms/GetForms';

import { PageContainer } from 'components/PageContainer';

const columns: GridColDef<Form>[] = [
  {
    field: 'name',
    type: 'string',
    headerName: 'Title',
    minWidth: 600,
  },
  {
    field: 'duration_valid',
    headerName: 'Expires',
    minWidth: 250,
    valueFormatter: (_value, row) => {
      if (!row.duration_valid) return 'Never';

      return `${dayjs.duration(row.duration_valid).humanize()} from date issued`;
    },
  },
  //   {
  //     field: 'advertise',
  //     type: 'boolean',
  //     headerName: 'Enabled',
  //     minWidth: 150,
  //   },
  //   {
  //     field: 'secure_seat_mode',
  //     type: 'singleSelect',
  //     headerName: 'Secure Seat Mode',
  //     minWidth: 175,
  //     valueOptions: [
  //       {
  //         value: 'at_time_of_enrollment',
  //         label: 'At Time Of Enrollment',
  //       },
  //       {
  //         value: 'when_deposit_paid',
  //         label: 'When Deposit Paid',
  //       },
  //       {
  //         value: 'when_full_cost_paid',
  //         label: 'When Paid In Full',
  //       },
  //     ],
  //   },
];

export function FormList() {
  const navigate = useNavigate();

  // fetch forms
  const forms = useGetForms();

  return (
    <PageContainer title="Manage Forms">
      <DataGrid
        columns={columns}
        rows={forms.data}
        loading={forms.isPending}
        onRowClick={(params) => navigate(`/admin/forms/${params.row.id}`)}
      />
    </PageContainer>
  );
}

export default FormList;
